
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SensorService {
  createSensor(data: any, perimeterEntity: any): Sensor {
    return new Sensor(data, perimeterEntity);
  }
}

export class Sensor {
  private id: string;
  private type: string;
  private meta_data: any;
  private arcAngelPerimeter: any;
  private geometry: any;

  constructor(data: any, perimeterEntity: any) {
    this.id = data._id;
    this.type = data.type;
    this.meta_data = data.meta_data;
    this.arcAngelPerimeter = perimeterEntity;
    this.geometry = data.geometry;
  }

  getId(): string {
    return this.id;
  }

  getType(): string {
    return this.type;
  }

  getPerimeterEntity(): any {
    return this.arcAngelPerimeter;
  }

  getMetaData(): any {
    return this.meta_data;
  }

  getGeometry(): any {
    return this.geometry;
  }
}